import TeamsBaseComponent, {ITeamsBaseComponentState} from "msteams-react-base-component";
import {DatePicker, DayOfWeek} from "office-ui-fabric-react";
import React = require("react");
import {MetadataFields} from "../../../models";
import {DarkModeCalloutStyles} from "../../DarkModeCalloutStyles";
import {TeamsDocumentStatusTabReorderMetadata} from "./TeamsDocumentStatusTabReorderMetadata";

export interface TeamsDocumentStatusTabDateMetadataState extends ITeamsBaseComponentState {}

export interface TeamsDocumentStatusTabDateMetadataProps {
    metadata: MetadataFields;
    metadataListIndex: number;
    metadataLastListIndex: number;
    shouldReorderMetadata: boolean;
    isDarkMode: boolean;
    validationErrors: string[];
    setListDateCallback: (date: Date, field: string) => void;
    reorderCallback: (metadata: MetadataFields, isDirectionUp: boolean) => void;
}

export class TeamsDocumentStatusTabDateMetadata extends TeamsBaseComponent<
    TeamsDocumentStatusTabDateMetadataProps,
    TeamsDocumentStatusTabDateMetadataState
> {
    constructor(props: TeamsDocumentStatusTabDateMetadataProps) {
        super(props);
    }

    public render() {
        const date = this.props.metadata.Value != "" ? new Date(this.props.metadata.Value) : null;
        const isDisabled = this.props.metadata.Disabled || this.props.metadata.ManuallyDisabled;
        return (
            <div className={this.props.shouldReorderMetadata ? "metadataWrapper" : ""}>
                <div className={this.props.shouldReorderMetadata ? "metadataField" : ""}>
                    <DatePicker
                        disabled={isDisabled}
                        styles={this.props.isDarkMode ? DarkModeCalloutStyles.getDatePickerStyle() : null}
                        label={this.props.metadata.Field}
                        isRequired={this.props.metadata.Required}
                        firstDayOfWeek={DayOfWeek.Sunday}
                        placeholder="Select a date..."
                        ariaLabel="Select a date"
                        value={date}
                        onSelectDate={(date) => this.props.setListDateCallback(date, this.props.metadata.Field)}
                        // DatePicker uses English strings by default. For localized apps, you must override this prop.
                    />
                    {this.isMissingRequiredValue() && (
                        <p
                            style={{
                                color: "rgb(164, 38, 44)",
                                marginTop: "5px",
                                fontSize: "12px",
                                fontFamily: "Segoe UI",
                                fontWeight: 400,
                            }}
                        >
                            {this.props.metadata.Field} is required
                        </p>
                    )}
                </div>
                <TeamsDocumentStatusTabReorderMetadata
                    metadata={this.props.metadata}
                    shouldReorderMetadata={this.props.shouldReorderMetadata}
                    reorderCallback={this.props.reorderCallback}
                    metadataListIndex={this.props.metadataListIndex}
                    metadataListLastIndex={this.props.metadataLastListIndex}
                />
            </div>
        );
    }

    private isMissingRequiredValue() {
        return (
            this.props.metadata.Required &&
            this.props.validationErrors.filter((i) => i == this.props.metadata.Field + " is required").length > 0 &&
            this.props.metadata.Value == ""
        );
    }
}
